import { EXCHANGES } from "@shared/common/constants";
import { GroupData } from "@shared/types";

const FUTURES_AS_SPOT_MINIMUM_PERCENTAGE = 95;

export const SPOT_BOT_FUTURES_EXCHANGES: Record<string, string[]> = {
  [EXCHANGES.BINANCE]: [
    EXCHANGES.BINANCE_FUTURES,
    EXCHANGES.BINANCE_COIN_FUTURES,
  ],
  [EXCHANGES.BYBIT_SPOT]: [EXCHANGES.BYBIT_USDT, EXCHANGES.BYBIT_INVERSE],
  [EXCHANGES.OKX]: [EXCHANGES.OKX_FUTURES, EXCHANGES.OKX_INVERSE],
  [EXCHANGES.OKX_EU_SPOT]: [EXCHANGES.OKX_EU_FUTURES],
  [EXCHANGES.KUCOIN]: [EXCHANGES.KUCOIN_FUTURES],
  [EXCHANGES.BITGET_SPOT]: [EXCHANGES.BITGET_FUTURES, EXCHANGES.BITGET_INVERSE],
  [EXCHANGES.HYPERLIQUID_SPOT]: [EXCHANGES.HYPERLIQUID_FUTURES],
  [EXCHANGES.BINGX_SPOT]: [EXCHANGES.BINGX_FUTURES],
  [EXCHANGES.MEXC_SPOT]: [EXCHANGES.MEXC_FUTURES],
  [EXCHANGES.FTX]: [EXCHANGES.FTX_FUTURES],
};

const countSignals = (group: GroupData | undefined, exchange: string): number =>
  Object.values(
    group?.exchange_to_main_coin_to_last_month_signals_count?.[exchange] || {}
  ).reduce((total, count) => total + count, 0);

/** Whether the channel posted spot signals this exchange could open, which
 * following futures on spot skips. */
export const hasSpotSignals = (exchange?: string, group?: GroupData) =>
  !!exchange && countSignals(group, exchange) > 0;

export const shouldRecommendFuturesAsSpot = (
  exchange?: string,
  group?: GroupData
): boolean => {
  if (!exchange || !SPOT_BOT_FUTURES_EXCHANGES[exchange]) return false;
  const futuresCount = SPOT_BOT_FUTURES_EXCHANGES[exchange].reduce(
    (total, futuresExchange) => total + countSignals(group, futuresExchange),
    0
  );
  const totalCount = futuresCount + countSignals(group, exchange);
  return (
    totalCount > 0 &&
    futuresCount * 100 >= totalCount * FUTURES_AS_SPOT_MINIMUM_PERCENTAGE
  );
};
